import { Mui } from "@osu/react-ui";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { pick } from "lodash";
import { constructPersonString } from "../../transform";
import useLookup from "../../hooks/useLookup";
import { personInfo } from "../../../util/constants";

function ApproverLookup(props = {}) {
  const { value: val, onChange, student, className } = props;
  const lookupButton = useRef();
  const [approverValue, setApproverValue] = useState("");
  const [lookupClicked, setLookUpClicked] = useState(false);
  const { person = {}, getPerson, setPersonEmplid, status } = useLookup({ student });
  const loading = status === "loading";
  const value = Object.prototype.hasOwnProperty.call(val || {}, 'emplid') && !isNaN(val.emplid) ? val.emplid : val
  const updateValue = (value) && value !== approverValue
  const triggerChange = lookupClicked && person?.emplid
  const error = (['notfound', 'error'].includes(status));

  useEffect(() => {
    if(updateValue) {
      setApproverValue(value);
      setPersonEmplid(value);
    }
  }, [setPersonEmplid, updateValue, value]);

  useEffect(() => {
    if(triggerChange) {
      onChange(pick(person, Object.keys(personInfo.write)));
      setLookUpClicked(false)
    }
  }, [onChange, person, triggerChange]);

  return (
    <div className={className}>
      {(person?.emplid) ?
        (<Mui.Box className="margin-left-2" display="flex" flexDirection="row">{constructPersonString(person)}</Mui.Box>) :
        (<Fragment>
          <Mui.Button
            id="textField1"
            className="text-transform-none"
            marginleft={5}
            value={value}
            disabled={loading}
            onChange={(e) => {
              const value = e.target.value?.trim();
              onChange(value);
              setApproverValue(value);
            }}>
          <Mui.TextField variant="outlined" label="OSU ID or Name.#" value={value} error={error === true}
            helperText={error === true ? 
              "The approver couldn't be found. Please re-check your OSU ID or Name.# and try again." :
              ""
            }
            inputProps={{
              onKeyDown: (e) => {
                if(e.key === "Enter") {
                  e.preventDefault(); // prevent form submission
                  // click the lookup button when enabled
                  if(lookupButton?.current && lookupButton.current?.disabled === false) {
                    lookupButton.current.click();
                  }
                }
              }
            }} />
          </Mui.Button>
          <Mui.Button
            ref={lookupButton}
            color="primary"
            variant="contained"
            disabled={loading || !approverValue}
            onClick={() => {
              setLookUpClicked(true)
              getPerson(approverValue);
            }}
            endIcon={loading && <Mui.CircularProgress color="inherit" size={20} />}
            >
              Lookup
          </Mui.Button>
        </Fragment>)
      }
    </div>
  );
}

export default ApproverLookup;